import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { CoTile } from "./parts";
import { companyLine, TONE } from "./portal";
import { OfferDetail, InterviewDetail, FeedbackDetail } from "./AppOutcomes";
import { ResultDetail } from "./AppResult";

function AppDetail({ a, s, d }) {
  if (s.key === "offer") return <OfferDetail a={a} onDone={d.reload} />;
  if (s.iv) return <InterviewDetail iv={s.iv} />;
  if (s.key === "rejected") return <FeedbackDetail a={a} opps={d.opp?.opportunities} />;
  return <ResultDetail a={a} />;
}

export function AppRow({ a, s, open, onToggle, d }) {
  const nav = useNavigate();
  return (
    <li className={cn("hs-card overflow-hidden transition-colors", open && "border-foreground/20")} data-testid={`application-${a.id}`}>
      <div className="flex items-center gap-4 px-4 sm:px-5 py-4">
        <CoTile name={a.company_name || a.job?.title} className="hidden sm:flex" />
        <button onClick={onToggle} aria-expanded={open} className="min-w-0 flex-1 md:flex-none md:w-[34%] text-left leading-tight" data-testid={`app-toggle-${a.id}`}>
          <span className="block font-semibold truncate">{a.job?.title}</span>
          <span className="block text-sm text-muted-foreground truncate">{companyLine(a.company_name, a.job)}</span>
          <span className={cn("md:hidden block text-[13px] mt-1 truncate", TONE[s.tone])}>{s.label} · {s.when}</span>
        </button>
        <span className="hidden md:block flex-1 text-sm truncate" data-testid={`app-status-${a.id}`}>{s.label}</span>
        <span className="hidden md:block flex-1 text-sm text-muted-foreground truncate" data-testid={`app-when-${a.id}`}>{s.when}</span>
        <button onClick={() => (s.to ? nav(s.to) : onToggle())} data-testid={`app-action-${a.id}`}
          className={cn("shrink-0 h-9 px-4 rounded-lg text-[13px] font-semibold transition-[filter,background-color]",
            s.primary ? "bg-primary text-primary-foreground hover:brightness-110" : "bg-foreground/[0.07] hover:bg-foreground/[0.12]")}>
          {!s.to && open ? "Close" : s.action}
        </button>
      </div>
      {open && <div className="border-t border-border px-4 sm:px-5 py-5 hs-rise" data-testid={`app-detail-${a.id}`}><AppDetail a={a} s={s} d={d} /></div>}
    </li>
  );
}
